import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) { }
  erpUser: any={}
  ngOnInit(): void {
    if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
      let erpUserString = sessionStorage.getItem('erpUser');
      this.erpUser = erpUserString && JSON.parse(erpUserString);

    }
    if (this.erpUser['account_name'] == undefined || this.erpUser['account_name'] == null || this.erpUser['account_name'] == "")
      this.erpUser['account_name'] = 'Account 1'
      if (this.erpUser['party_name'] == undefined || this.erpUser['party_name'] == null || this.erpUser['party_name'] == "")
      this.erpUser['party_name'] = 'John Doe'
  }

  toggleSidebar() {
    this.toggleSidebarForMe.emit();
  }
  logOut() {
    sessionStorage.removeItem('erpUser')
    sessionStorage.removeItem('svm_jwt')

    this.router.navigate(['./login'])
  }
}
